import { render, staticRenderFns } from "./trial-balance.vue?vue&type=template&id=771a4dd5&"
import script from "./trial-balance.vue?vue&type=script&lang=js&"
export * from "./trial-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports